import { WarningObject } from "@utils/Warnings";

export interface ErrorState {
  hasError: boolean;
  errors: WarningObject[];
}

export const errorInitialState: ErrorState = {
  hasError: false,
  errors: [],
};

export type ErrorAction =
  | { type: 'SET_ERRORS'; payload: WarningObject[] }
  | { type: 'CLEAR_ERROR' };

export const errorReducer = (state: ErrorState, action: ErrorAction): ErrorState => {
  switch (action.type) {
    case 'SET_ERRORS':
      return {
        ...state,
        hasError: action.payload && action.payload.length > 0,
        errors: action.payload,
      };

    default:
      return state;
  }
};